<div class="ic">
	<header class="ic__header">
		<h4 class="ic__title">InfoCenter</h4>
		<button class="ic__close" type="button" (click)="toggleInfoCenter()" [attr.aria-label]="'infocenter.close' | translate">
			<i class="fa fa-times"></i>
		</button>
	</header>

	<div class="ic__controls">
		<div class="ic__search">
			<i class="fa fa-search ic__search-icon"></i>
			<input
				class="ic__search-input"
				type="search"
				[value]="searchTerm"
				[placeholder]="'infocenter.search' | translate"
				(input)="onSearchChange($any($event.target).value)" />
			<button
				*ngIf="searchTerm"
				class="ic__search-clear"
				type="button"
				(click)="clearSearch()"
				[attr.aria-label]="'infocenter.resetFilters' | translate">
				<i class="fa fa-times"></i>
			</button>
		</div>

		<button class="ic__settings-toggle" type="button" (click)="toggleSettings()">
			<fa-icon [icon]="settingsOpen ? 'chevron-down' : 'chevron-right'"></fa-icon>
			<span>{{ 'infocenter.settings' | translate }}</span>
		</button>

		<ng-container *ngIf="settingsOpen">
		<div class="ic__selects">
			<label class="ic__select">
				<span class="ic__select-label">{{ 'infocenter.grouping' | translate }}</span>
				<select [value]="groupMode" (change)="setGroupMode($any($event.target).value)">
					<option value="none">{{ 'infocenter.none' | translate }}</option>
					<option value="department">{{ 'infocenter.department' | translate }}</option>
					<option value="group">{{ 'infocenter.group' | translate }}</option>
					<option *ngIf="hasTeamData" value="team">{{ 'infocenter.team' | translate }}</option>
					<option value="status">{{ 'infocenter.state' | translate }}</option>
				</select>
			</label>

			<label class="ic__select">
				<span class="ic__select-label">{{ 'infocenter.sorting' | translate }}</span>
				<span class="ic__select-row">
					<select [value]="sortMode" (change)="setSortMode($any($event.target).value)">
						<option value="name">{{ 'infocenter.name' | translate }}</option>
						<option value="status">{{ 'infocenter.state' | translate }}</option>
						<option value="lastBooking">{{ 'infocenter.lastBooking' | translate }}</option>
					</select>
					<button
						class="ic__sort-dir"
						type="button"
						(click)="toggleSortDirection()"
						[title]="(sortAscending ? 'infocenter.sortAscending' : 'infocenter.sortDescending') | translate"
						[attr.aria-label]="
							(sortAscending ? 'infocenter.sortAscending' : 'infocenter.sortDescending') | translate
						">
						<fa-icon [icon]="sortAscending ? 'sort-alpha-up' : 'sort-alpha-down'"></fa-icon>
					</button>
				</span>
			</label>
		</div>

		<div class="ic__chips" *ngIf="hasTeamData && isTeamleader">
			<button
				class="ic__chip"
				type="button"
				[class.ic__chip--active]="!selectedTeamIds.length"
				(click)="clearTeams()">
				{{ 'infocenter.all' | translate }}
			</button>
			<button
				*ngFor="let team of availableTeams"
				class="ic__chip"
				type="button"
				[class.ic__chip--active]="isTeamSelected(team.id)"
				(click)="toggleTeam(team.id)">
				{{ team.name }}
			</button>
		</div>

		<label class="ic__switch" *ngIf="hasAssignmentData">
			<input type="checkbox" [checked]="onlyMyEmployees" (change)="toggleOnlyMyEmployees()" />
			<span>{{ 'infocenter.onlyMyEmployees' | translate }}</span>
		</label>
		</ng-container>
	</div>

	<div class="ic__list" [class.ic__list--no-order]="!showOrderColumn">
		<div class="ic__colhead">
			<span></span>
			<span>{{ 'infocenter.name' | translate }}</span>
			<span>{{ 'infocenter.state' | translate }}</span>
			<span *ngIf="showOrderColumn">{{ 'infocenter.order' | translate }}</span>
		</div>

		<div class="ic__empty" *ngIf="!groups.length">
			<p>{{ 'infocenter.noResults' | translate }}</p>
			<button *ngIf="hasActiveFilters()" class="ic__reset" type="button" (click)="resetFilters()">
				{{ 'infocenter.resetFilters' | translate }}
			</button>
		</div>

		<section class="ic__group" *ngFor="let group of groups; trackBy: trackByGroup">
			<h5 class="ic__group-title" *ngIf="groupMode !== 'none'">
				<span>{{ group.key ? (group.translateLabel ? ('infocenter.' + group.key | translate) : group.label) : ('infocenter.unassigned' | translate) }}</span>
				<span class="ic__group-count">{{ group.users.length }}</span>
			</h5>

			<div class="ic__row" *ngFor="let user of group.users; trackBy: trackByUser">
				<span class="ic__dot"><i class="fa fa-circle" [ngClass]="statusIconClass(user)"></i></span>
				<span class="ic__name">{{ user.Name }}</span>
				<span class="ic__status">{{ displayStatus(user) }}</span>
				<span class="ic__order" *ngIf="orderText(user)" [title]="orderText(user)">{{ orderText(user) }}</span>
			</div>
		</section>
	</div>
</div>
